"use strict";

const OverdueTreatmentsCtrl = function (CRUDService, config, PatientsService, $rootScope) {
  var ctrl = this;
  ctrl.$onInit = function () {
    ctrl.request = CRUDService.getAll(config.urls.patients + '/search/findOverdueTreatments').then(function (data) {
      ctrl.warnings = data;
      if ($rootScope.user.hasPermission("00110")) {
        var pids = data.map(function (patient) { return patient.patient.pid; });
        PatientsService.getPatientData(pids, undefined, undefined, undefined, 1000).then(function (pdata) {
          pdata.data.pageList.forEach(function (record) {
            ctrl.warnings.forEach(function (patient) {
              if (patient.patient.pid === record.ids[0].idString) {
                patient.patient.vorname = record.fields.vorname;
                patient.patient.nachname = record.fields.nachname;
                patient.patient.birthdate = new Date(record.fields.geburtsjahr + "/" + record.fields.geburtsmonat + "/" + record.fields.geburtstag);   
              }
            });
          });
        }, function (error) {
          console.log(error);
        });
      }
    }
    );
  };
};

OverdueTreatmentsCtrl.$inject = ['CRUDService', 'config', 'PatientsService', '$rootScope'];

module.exports = {
  template: require('./overdue-treatments.component.html'),
  controller: OverdueTreatmentsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/list-overdue-treatments/overdue-treatments.component.js